import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { TanStackQueryIds } from '../../query/query-ids'
import { setElementalKnowledgeBase } from '~~/src/api/elementals'
import type { Elemental } from '~~/src/types/elemental'

export const useKnowledgeBaseMutation = () => {
  const queryClient = useQueryClient()
  const toast = useToast()

  return useMutation({
    mutationFn: async ({ isKnowledgeBase, elemental }: { isKnowledgeBase: boolean; elemental: Elemental }) => {
      return await setElementalKnowledgeBase(elemental.id, isKnowledgeBase)
    },
    onSuccess: (_, { elemental, isKnowledgeBase }) => {
      toast.success(isKnowledgeBase ? 'Marked as knowledge base' : 'Removed from knowledge base')
      queryClient.invalidateQueries({ queryKey: ['profile-list-elementals', 'all', 'library', true] })
      queryClient.invalidateQueries({
        queryKey: [TanStackQueryIds.RECENT_ELEMENTAL],
        type: 'all',
      })
      queryClient.invalidateQueries({ queryKey: [TanStackQueryIds.FAVORITES] })

      queryClient.invalidateQueries({ queryKey: ['profile-list-elementals', elemental.elementalTypeId] })
      queryClient.invalidateQueries({ queryKey: ['elemental', elemental.elementalTypeId] })
    },
  })
}
